import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';
import { InputModule } from '../input/input.module';
import { AskUpdateComponent } from './components/ask-update/ask-update.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    CaptchaInputModule,
    MatIconModule,
    MatButtonModule
  ],
  declarations: [AskUpdateComponent],
  exports: [AskUpdateComponent],
})
export class AskUpdateModule { }
